<!--
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:14:49
 * @LastEditors: liuqi
 * @LastEditTime: 2023-08-10 10:09:48
 * @Description: 统计数据卡片模块
 -->
<template>
  <div class="work-data">
    <div class="work-data__times">
      <!-- <p>统计区间：<span>{{startTime}}</span> 至 <span>{{endeTime}}</span></p> -->
      <p>统计截至 <span>2023年9月份</span></p>
      <!-- <p>统计截至 <span>{{updateTime}}</span></p> -->
    </div>
    <!-- <a-popover class="work-data__descript" placement="bottomRight" overlayClassName="work-data__descript-detail">
      <template slot="content">
        <p>数据说明数据说明数据说明数据说明数据说明数据说明数据说明数据说明数据说明数据说明数据说明</p>
      </template>
      <a-icon type="question-circle" />
      <span>数据说明</span>
    </a-popover> -->
    <div class="work-data__card-container work-data__row1">
      <num-card :total="monthNum" danwei="处" name="本月新增" color="#F74C32" bgcolor="#FDF2F1"/>
      <num-card :total="seasonNum" danwei="处" name="本季新增" color="#7A73FF" bgcolor="#F1F0FD" />
      <num-card :total="yearNum" danwei="处" name="本年新增" color="#29B7A3" bgcolor="#F7FFFE"/>
    </div>
    <div class="work-data__card-container work-data__row2">
      <num-card :total="countyMonth" danwei="个" name="涉及区县" color="#45AAFB" bgcolor="#F7FDFF"/>
      <num-card :total="countySeason" danwei="个" name="涉及区县" color="#F78704" bgcolor="#FFF9F2" />
      <num-card :total="countyYear" danwei="个" name="涉及区县" color="#EB4DDB" bgcolor="#FCF7FF"/>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import NumCard from '@/components/num-card'
import {
  SPOT_LASTEST,
  SPOT_LASTEST_BY_STAGES,
  SPOT_STATISTICS,
  SPOT_STATISTICS_BY_BATCHIDS,
  SPOT_RELATE_REGION,
} from '@/assets/const-value/interface'

export default {
  components: {
    NumCard,
  },
  data() {
    return {
      startTime: null,
      endeTime: null,
      updateTime: null,

      monthNum: 0,
      seasonNum: 0,
      yearNum: 0,
      countyMonth: 0,
      countySeason: 0,
      countyYear: 0,
    }
  },
  created() {
    this.getData()
    this.getData2()
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     this.getStatisticsTime()
  //   })
  // },
  methods: {
    /**
     * 获取覆盖率数据
     */
    getStatisticsTime() {
      this.updateTime = moment().format('YYYY年10月份')
      // this.updateTime = moment().subtract(1, 'month').format('YYYY年M月份')
    },
    /**
     * 获取数据
     */
    async getData() {
      const regionIds = [
        110000, 120000, 130000, 140000, 150000, 210000, 220000, 230000, 310000, 320000,
        330000, 340000, 350000, 360000, 370000, 410000, 420000, 430000, 440000, 450000, 460000, 500000,
        510000, 520000, 530000, 540000, 610000, 620000, 630000, 640000, 650000, 710000, 810000, 820000,
      ]
      // var stage0 =  moment().subtract(1, 'month').format('YYYY-Q').replace('-', 'S')
      // var stage1 = `${stage0}${moment().subtract(1, 'month').format('MM')}`
      const stageYear = await this.$axios.post(SPOT_LASTEST_BY_STAGES, { stages: [ '2023S1', '2023S2', '2023S3' ] })
      const stageSeason = await this.$axios.get(SPOT_LASTEST, { params: { stage: '2023S3' } })
      const stageMonth = await this.$axios.get(SPOT_LASTEST, { params: { stage: '2023S309' } })
      const year = await this.$axios.post(SPOT_STATISTICS_BY_BATCHIDS, { batchIds: stageYear.data, regionIds: regionIds.join(',') })
      const season = await this.$axios.get(SPOT_STATISTICS(stageSeason.data.id), { params: { regionIds: regionIds.join(',') } })
      const month = await this.$axios.get(SPOT_STATISTICS(stageMonth.data.id), { params: { regionIds: regionIds.join(',') } })

      let yearNum = 0
      year.data.forEach((i) => {
        i.data.forEach((j) => {
          if (j.type === '11' || j.type === '12') {
            yearNum += j.num // num 是当年的，而不是全部年份的，currentNum是当期的
          }
        })
      })
      let seasonNum = 0
      season.data.forEach((i) => {
        i.data.forEach((j) => {
          if (j.type === '11' || j.type === '12') {
            seasonNum += j.currentNum
          }
        })
      })
      let monthNum = 0
      month.data.forEach((i) => {
        i.data.forEach((j) => {
          if (j.type === '11' || j.type === '12') {
            monthNum += j.currentNum
          }
        })
      })

      this.monthNum = monthNum
      this.seasonNum = seasonNum
      this.yearNum = yearNum

      // this.countyMonth = 1863
      // this.countySeason = 2200
      // this.countyYear = 2964

      this.$store.commit('work/SET_SPOT_STATISTICS', season.data)
    },
    getData2() {
      // 月度关联区县
      this.$axios.get(SPOT_RELATE_REGION, { params: {
        stage: [ '2023S3' ],
        batchs: [ '202309' ],
        types: [ '11', '12' ],
      } }).then((res) => {
        if (res.code === 0 && res.data) {
          const {
            area,
          } = res.data
          this.countyMonth = area
        }
      })
      // 季度关联区县
      this.$axios.get(SPOT_RELATE_REGION, { params: {
        stage: [ '2023S3' ],
        types: [ '11', '12' ],
      } }).then((res) => {
        if (res.code === 0 && res.data) {
          const {
            area,
          } = res.data
          this.countySeason = area
        }
      })
      // 年关联区县
      this.$axios.get(SPOT_RELATE_REGION, { params: {
        stage: [ '2023S1', '2023S2', '2023S3' ],
        types: [ '11', '12' ],
      } }).then((res) => {
        if (res.code === 0 && res.data) {
          const {
            area,
          } = res.data
          this.countyYear = area
        }
      })
    },
  },
}
</script>

<style lang="scss">
.work-data {
  position: relative;
  padding: 0 40px;
}
.work-data__times {
  font-size: 24px;
  font-family:PingFangSC-Light,PingFang SC;
  font-weight:300;
  color: #757575;
  p {
    margin: 0.9em 0;
  }
  span {
    color: #222;
    font-weight: 500;
  }
}
.work-data__descript {
  position: absolute;
  top: 14px;
  right: 40px;
  font-size: 20px;
  font-family: PingFangSC-Light,PingFang SC;
  font-weight: 300;
  color: #757575;
  >span {
    margin-left: 10px;
  }
}
.work-data__descript-detail {
  width: 200px;
  color: red;
}

.work-data__card-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .num-card {
    margin-right: 3px;
  }
  .num-card__name {
    font-weight: bold;
  }
  .num-card__total {
    span {
      font-size: 40px;
    }
  }
}
.work-data__row1 {
  div:nth-child(1) {
    border-top-left-radius: 10px;
  }
  div:nth-child(3) {
    border-top-right-radius: 10px;
    margin-right: 0;
  }
}
.work-data__row2 {
  div:nth-child(1) {
    border-bottom-left-radius: 10px;
  }
  div:nth-child(3) {
    border-bottom-right-radius: 10px;
    margin-right: 0;
  }
}
</style>
